import PriceDisplay from '@ui/PriceDisplay/component'

export default (el: HTMLElement): void => {
  el.querySelectorAll<HTMLElement>('.c-price-display').forEach((priceDisplayEl) => {
    PriceDisplay(priceDisplayEl)
  })
}
